import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { ISolicitudVehiculoModel } from 'src/app/models/interfaces/solicitud/ISolicitudVehiculoModel';
import { ISolicitudVehiculoAsignarDocumentoModel } from 'src/app/models/interfaces/solicitud/vehiculos/ISolicitudVehiculoAsignarDocumentoModel';
import { ISolicitudVehiculoValidarModel } from 'src/app/models/interfaces/solicitud/vehiculos/ISolicitudVehiculoValidarModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolicitudVehiculoService {

  private configUrl = [environment.apiGatewayUrl, 'solicitudes'].join('/');

  constructor(private http: HttpClient) { }

  guardar(model: ISolicitudVehiculoModel){
    return this.http.post<ISolicitudVehiculoModel>(`${this.configUrl}/${model.idSolicitud}/vehiculos`, model);
  }

  asignardocumento(idSolicitud: number,model: ISolicitudVehiculoAsignarDocumentoModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/${idSolicitud}/vehiculosdocumento`, model);
  }
  
  getById(idSolicitud: number, idSolicitudEquipo: number): Observable<ISolicitudVehiculoModel> {
    return this.http.get<ISolicitudVehiculoModel>(`${this.configUrl}/${idSolicitud}/vehiculos/${idSolicitudEquipo}`);
  }

  validar(model: ISolicitudVehiculoValidarModel){
    return this.http.post<ISolicitudVehiculoValidarModel>(`${this.configUrl}/vehiculos/validar`, model);
  }

  eliminar(idSolicitudVehiculo: number){
    return this.http.delete<ActionResultModel>(`${this.configUrl}/vehiculos/${idSolicitudVehiculo}`);
  }
}
